"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
// Components
var omniPrompt_1 = __importDefault(require("@haptik/helpers/build/esm/omniPrompt"));
// Constants
var constants_1 = require("../../constants");
var constants_2 = require("./constants");
// Icons
var EmptyChannelsPreview_svg_1 = __importDefault(require("../../icons/EmptyChannelsPreview.svg"));
var PreviewAndEditWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    padding: 0,
    flexDirection: 'column',
    overflow: 'hidden',
    borderLeft: "1px solid " + props.theme.colors.grey.haptik,
    width: 360,
}); });
var HeaderWrapper = styled_components_1["default"](box_1["default"])({
    padding: 16,
    flexDirection: 'column',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    zIndex: 1,
    position: 'sticky',
    top: 0,
});
var SectionWrapper = styled_components_1["default"](box_1["default"])({
    padding: 0,
    marginTop: 16,
    flexDirection: 'column',
});
var StyledTextInput = styled_components_1["default"](text_2["default"])({
    width: '100%',
    marginTop: 8,
});
var CharactersLimitText = styled_components_1["default"](text_1["default"])(function (props) { return ({
    marginTop: 8,
    color: props.warning
        ? props.theme.colors.red.haptik
        : props.theme.colors.grey.deep,
}); });
var EmptyStateIconWrapper = styled_components_1["default"](icon_1["default"])({
    width: 360,
    height: 270,
});
var EmptyStateText = styled_components_1["default"](text_1["default"])({
    textAlign: 'center',
});
var PreviewAndEdit = function (_a) {
    var social_prompt = _a.social_prompt, onChange = _a.onChange;
    var _b = react_1["default"].useState(''), focussedInput = _b[0], setFocussedInput = _b[1];
    var _c = react_1["default"].useState([]), errorFields = _c[0], setErrorFields = _c[1];
    // Returns the Characters Limit Message
    var getCharacterLimitText = function (type) {
        var textLabel = 'Maximum characters limit is ';
        switch (type) {
            case constants_2.CONSTANTS.HEADING:
                textLabel = textLabel + constants_2.CHARACTER_LIMIT.HEADING;
                break;
            case constants_2.CONSTANTS.BODY:
                textLabel = textLabel + constants_2.CHARACTER_LIMIT.BODY;
                break;
            case constants_2.CONSTANTS.CHANNEL:
                textLabel = textLabel + constants_2.CHARACTER_LIMIT.CHANNEL.whatsapp;
                break;
        }
        return renderCharactersLimitMessage(textLabel);
    };
    // Returns the Characters Limit Warning Message
    var getErrorMessage = function (type) {
        // If a field has warning and is in focus then remove it from focussed text.
        // Because we need to show only warning message in that case.
        if (focussedInput === type)
            setFocussedInput('');
        var textLabel = 'Maximum characters limit is ';
        var currentLengthText = ' The number of characters entered is ';
        switch (type) {
            case constants_2.CONSTANTS.HEADING:
                textLabel =
                    textLabel +
                        (constants_2.CHARACTER_LIMIT.HEADING + ".") +
                        currentLengthText +
                        (social_prompt.header.length + ".");
                break;
            case constants_2.CONSTANTS.BODY:
                textLabel =
                    textLabel +
                        (constants_2.CHARACTER_LIMIT.BODY + ".") +
                        currentLengthText +
                        (social_prompt.body.length + ".");
                break;
            case constants_1.SOCIAL_CHANNELS.KEYS.whatsapp:
            case constants_1.SOCIAL_CHANNELS.KEYS.messenger:
            case constants_1.SOCIAL_CHANNELS.KEYS.instagram:
                textLabel =
                    textLabel +
                        (constants_2.CHARACTER_LIMIT.CHANNEL[type] + ".") +
                        currentLengthText +
                        (social_prompt.channels.filter(function (channel) { return channel.type === type; })[0]
                            .text.length + ".");
                break;
        }
        return textLabel;
    };
    // Renders the Text
    var renderCharactersLimitMessage = function (textLabel, warning) {
        if (warning === void 0) { warning = false; }
        return (react_1["default"].createElement(CharactersLimitText, { themed: true, variant: "body.md", warning: warning }, textLabel));
    };
    // Value change handler for Preview and Edit
    var onValueChangeHandler = function (type, value) {
        // Handle the case for type CHANNEL, as its value is of form { type, value }.
        var isTypeChannel = type === constants_2.CONSTANTS.CHANNEL;
        // If character limit exceeds and is not present in errorFields, then add it.
        // Otherwise if length is under limit and type is present in errorFields, then remove it.
        if (isTypeChannel
            ? value.value.length > constants_2.CHARACTER_LIMIT[type][value.type] &&
                !errorFields.includes(value.type)
            : value.length > constants_2.CHARACTER_LIMIT[type] && !errorFields.includes(type)) {
            var errorField = isTypeChannel ? value.type : type;
            setErrorFields(__spreadArrays(errorFields, [errorField]));
        }
        else if (isTypeChannel
            ? value.value.length <= constants_2.CHARACTER_LIMIT[type][value.type] &&
                errorFields.includes(value.type)
            : value.length <= constants_2.CHARACTER_LIMIT[type] && errorFields.includes(type)) {
            setErrorFields(errorFields.filter(function (field) { return field !== (isTypeChannel ? value.type : type); }));
            setFocussedInput(isTypeChannel ? value.type : type);
        }
        // Updates the value in main state, present in Social Modal Trigger Component.
        onChange(type, value);
    };
    return (react_1["default"].createElement(PreviewAndEditWrapper, { "data-testid": "preview-and-edit" }, social_prompt.channels.length ? (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(HeaderWrapper, null,
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Preview & edit")),
        react_1["default"].createElement(box_1["default"], { padding: "16px", flexDirection: "column", overflowY: "auto" },
            react_1["default"].createElement(omniPrompt_1["default"], { config: social_prompt }),
            react_1["default"].createElement(SectionWrapper, null,
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Heading Text"),
                react_1["default"].createElement(StyledTextInput, { themed: true, placeholder: "Enter Heading Text", value: social_prompt.header, onFocus: function () {
                        return !errorFields.includes(constants_2.CONSTANTS.HEADING) &&
                            setFocussedInput(constants_2.CONSTANTS.HEADING);
                    }, onBlur: function () { return setFocussedInput(''); }, onChange: function (value) {
                        return onValueChangeHandler(constants_2.CONSTANTS.HEADING, value);
                    }, error: errorFields.includes(constants_2.CONSTANTS.HEADING) &&
                        getErrorMessage(constants_2.CONSTANTS.HEADING) }),
                focussedInput === constants_2.CONSTANTS.HEADING &&
                    getCharacterLimitText(constants_2.CONSTANTS.HEADING)),
            react_1["default"].createElement(SectionWrapper, null,
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Body Text"),
                react_1["default"].createElement(StyledTextInput, { themed: true, multiline: true, placeholder: "Enter Body Text", value: social_prompt.body, onFocus: function () {
                        return !errorFields.includes(constants_2.CONSTANTS.BODY) &&
                            focussedInput !== constants_2.CONSTANTS.BODY &&
                            setFocussedInput(constants_2.CONSTANTS.BODY);
                    }, onBlur: function () { return setFocussedInput(''); }, onChange: function (value) {
                        return onValueChangeHandler(constants_2.CONSTANTS.BODY, value);
                    }, error: errorFields.includes(constants_2.CONSTANTS.BODY) &&
                        getErrorMessage(constants_2.CONSTANTS.BODY) }),
                focussedInput === constants_2.CONSTANTS.BODY &&
                    getCharacterLimitText(constants_2.CONSTANTS.BODY)),
            social_prompt.channels.map(function (channel) { return (react_1["default"].createElement(SectionWrapper, null,
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" },
                    "Button Text for",
                    ' ',
                    channel.type === constants_1.SOCIAL_CHANNELS.KEYS.messenger
                        ? 'Messenger'
                        : constants_1.SOCIAL_CHANNELS.TITLE[channel.type]),
                react_1["default"].createElement(StyledTextInput, { themed: true, placeholder: "Enter Button Text", value: channel.text, onFocus: function () { return setFocussedInput(channel.type); }, onBlur: function () { return setFocussedInput(''); }, onChange: function (value) {
                        return onValueChangeHandler(constants_2.CONSTANTS.CHANNEL, {
                            type: channel.type,
                            value: value,
                        });
                    }, error: errorFields.includes(channel.type) &&
                        getErrorMessage(channel.type) }),
                focussedInput === channel.type &&
                    getCharacterLimitText(constants_2.CONSTANTS.CHANNEL))); })))) : (react_1["default"].createElement(box_1["default"], { padding: "0px", width: "100%", margin: "auto", flexDirection: "column" },
        react_1["default"].createElement(box_1["default"], { padding: "0px", width: "235px", margin: "auto" },
            react_1["default"].createElement(EmptyStateText, { variant: "body.lg" }, "Select at least one channel to generate preview.")),
        react_1["default"].createElement(EmptyStateIconWrapper, { src: EmptyChannelsPreview_svg_1["default"] })))));
};
exports["default"] = PreviewAndEdit;
